module.exports = __webpack_public_path__ + "static/img/20957831.e69bad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20957831.jpg
// module id = sI/Z
// module chunks = 0